import { render, staticRenderFns } from "./university-user.vue?vue&type=template&id=2b2050c4&scoped=true"
import script from "./university-user.vue?vue&type=script&lang=js"
export * from "./university-user.vue?vue&type=script&lang=js"
import style0 from "./university-user.vue?vue&type=style&index=0&id=2b2050c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2050c4",
  null
  
)

export default component.exports